








import Vue from "vue";
import Overview from "./KeyInfo/Overview.vue";
// @ts-ignore
import { Base64 } from "js-base64";

export default Vue.extend({
  name: "KeyInfo",
  components: { Overview },

  data() {
    return {
      dialog: false,
      tabActive: "tab1",
      keyData: null as any
    };
  },
  methods: {
    show(data: any) {
      this.initData(data);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    initData(data: any) {
      this.keyData = {
        name: data.metadata.name,
        description:
          data.metadata?.annotations?.["appmgr.object.description"] ?? "-",
        type: data.metadata?.annotations?.["appmgr.secrets.type"] ?? "-",
        createBy: data.metadata?.annotations?.["appmgr.object.createBy"] ?? "-",
        createTime: data.metadata.creationTimestamp
      };
      this.keyData.keyDataArr = [];
      this.keyData.dockerconfigArr = [];
      for (const item in data.data) {
        if (item !== ".dockerconfigjson") {
          this.keyData.keyDataArr.push({
            name: item,
            value: data.data[item]
          });
        } else {
          const dockerconfig = JSON.parse(Base64.decode(data.data[item]));
          this.keyData.dockerconfigAuths = Object.keys(dockerconfig.auths)[0];
          this.keyData.dockerconfigArr.push({
            name: "username",
            value: Base64.encode(
              dockerconfig.auths[this.keyData.dockerconfigAuths].username
            )
          });
          this.keyData.dockerconfigArr.push({
            name: "password",
            value: Base64.encode(
              dockerconfig.auths[this.keyData.dockerconfigAuths].password
            )
          });
        }
      }
    }
  }
});
